// ==========================================
// Financial Table Variables
// ==========================================
@table-font-main:
    'Hanken Grotesk',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    sans-serif;

@table-font-header: @table-font-main;
@table-font-row: @table-font-main;

@table-fs-header: 13px;
@table-fs-row: 12px;

// Layout & Spacing
@table-cell-padding: 6px 12px;
@table-border-color: #e2e8f0; // Smooth slate border

// Color Profiles
@table-bg-header: #f8fafc;
@table-bg-zebra-even: #ffffff;
@table-bg-zebra-odd: #f1f5f9; // Set to transparent if you don't want alternating rows

@table-color-text: #1e293b;
@table-color-header: #0f172a;

// ==========================================
// Table Component Mixin / Stylesheet
// ==========================================
.prose_table {
    width: 100%;
    overflow-x: auto;
    margin: 0 0;

    table {
        width: 100%;
        border-collapse: collapse;
        color: @table-color-text;

        // Header Configuration
        thead {
            tr {
                background-color: @table-bg-header;
            }

            th {
                font-family: @table-font-header;
                font-size: @table-fs-header;
                font-weight: 600;
                color: @table-color-header;
                padding: @table-cell-padding;
                border: 1px solid @table-border-color;
                text-align: center;
                white-space: nowrap;

                // Keep the primary data label column header left-aligned
                &:first-child {
                    text-align: left;
                }
            }
        }

        // Body Configuration
        tbody {
            tr {
                background-color: @table-bg-zebra-even;

                &:nth-child(odd) {
                    background-color: @table-bg-zebra-odd;
                }

                &:hover {
                    background-color: fade(@table-border-color, 30%);
                }
            }

            td {
                font-family: @table-font-row;
                font-size: @table-fs-row;
                padding: @table-cell-padding;
                border: 1px solid @table-border-color;
                text-align: center;
                white-space: nowrap;

                // Formats numbers to stack cleanly even on proportional sans-serif fonts
                font-variant-numeric: tabular-nums;

                // Keep the line-item metrics/labels left-aligned while numbers remain centered
                &:first-child {
                    text-align: left;
                    font-weight: 500;
                }

                // Supports bold styling for major calculated lines like Total Assets
                strong,
                b {
                    font-weight: 700;
                    color: @table-color-header;
                }
            }
        }
    }
}
